import { useFormik } from "formik"
import { useEffect, useState } from "react"
import { Form, Modal } from "react-bootstrap"
import { ContentHeader } from "../../components"
import { layThongTinCauHinh, luuCauHinh } from "../../services/setting"
import * as Yup from 'yup';
import { toast } from "react-toastify";
import { Col, Row, Tabs, Button, Switch } from "antd";
import { SaveOutlined, CheckOutlined, CloseOutlined } from '@ant-design/icons';
import { useDispatch } from 'react-redux';
import { hideLoadingScreen, showLoadingScreen } from '../../store/reducers/loading';
import NgayLamViec from "../setting/NgayLamViec"
import CauHinhLuongTab from "./CauHinhLuongTab"
import CauHinhThueTab from "./CauHinhThueTab"
import CauHinhHanChotKPITab from "./CauHinhHanChotKPITab"
import CauHinhKeHoachDaoTaoTab from "./CauHinhKeHoachDaoTaoTab"
import NhanVienSelectBox from "../utils/NhanVienSelectBox";
import SoHieuVanBanTab from "./SoHieuVanBanTab";

const Setting = () => {
    const [openModalLuu, setOpenModalLuu] = useState<boolean>(false);
    const [stateSinhNhat, setStateSinhNhat] = useState<boolean>(false);
    const dispatch = useDispatch();

    const { handleChange, values, handleSubmit, touched, errors, setFieldValue, setErrors, setTouched } = useFormik({
        initialValues: {
            "hostMail": "",
            "portMail": 0,
            "userNameMail": "",
            "passwordMail": "",
            "thoiHan": 0,
            "sinhNhatQuy":0,
            "duyetNhuCauTaiSan_PhoCVP": undefined,
            "duyetNhuCauTaiSan_CVP": undefined,
            "duyetNhuCauTaiSan_PhoGD": undefined,
            "duyetNhuCauTaiSan_GD": undefined,
            "duyetNhuCauTaiSan_CVVP": undefined,
        },
        validationSchema: Yup.object({
            hostMail: Yup.string().required('Bắt buộc'),
            portMail: Yup.number().required('Bắt buộc'),
            userNameMail: Yup.string().required('Bắt buộc'),
            passwordMail: Yup.string().required('Bắt buộc'),
            thoiHan: Yup.number().required('Bắt buộc')
        }),
        onSubmit: (values) => {
            setOpenModalLuu(true)
        }
    });

    const layThongTin = async () => {
        dispatch(showLoadingScreen());
        var data = await layThongTinCauHinh();
        setFieldValue("hostMail", data.hostMail || "");
        setFieldValue("portMail", data.portMail || 0);
        setFieldValue("userNameMail", data.userNameMail || "");
        setFieldValue("passwordMail", data.passwordMail || "");
        setFieldValue("thoiHan", data.thoiHan || 0);
        setFieldValue("sinhNhatQuy", data.sinhNhatQuy || 0);
        setFieldValue("duyetNhuCauTaiSan_PhoCVP", data.duyetNhuCauTaiSan_PhoCVP || undefined);
        setFieldValue("duyetNhuCauTaiSan_CVP", data.duyetNhuCauTaiSan_CVP || undefined);
        setFieldValue("duyetNhuCauTaiSan_PhoGD", data.duyetNhuCauTaiSan_PhoGD || undefined);
        setFieldValue("duyetNhuCauTaiSan_GD", data.duyetNhuCauTaiSan_GD || undefined);
        setFieldValue("duyetNhuCauTaiSan_CVVP", data.duyetNhuCauTaiSan_CVVP || undefined);
        setStateSinhNhat(data.sinhNhatQuy == 1 ? true : false);
        dispatch(hideLoadingScreen());
    }

    const onSave = async (request: any) => {
        dispatch(showLoadingScreen());
        let rs = await luuCauHinh(request);
        if (rs === true) {
            setErrors({});
            setTouched({});
            toast.success('Lưu thông tin thành công');
            dispatch(hideLoadingScreen());
            setOpenModalLuu(false);
        }
        else {
            toast.error('Lưu thông tin không thành công')
            dispatch(hideLoadingScreen());
            setOpenModalLuu(false)
        }
    };
    useEffect(() => {
        layThongTin();
    }, []);
    return <section>
        <ContentHeader title="Cấu hình hệ thống" />
        <Modal show={openModalLuu} onHide={() => setOpenModalLuu(false)}>
            <Modal.Header closeButton>
                <Modal.Title>Lưu thông tin</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                Bạn có muốn lưu thông tin cấu hình không?
            </Modal.Body>
            <Modal.Footer style={{
                "display": "flex",
                "justifyContent": "space-between"
            }}>
                <Button type="primary" danger className="btn-sm" onClick={() => setOpenModalLuu(false)}>
                    Đóng
                </Button>
                <Button type="primary" className="btn-sm" onClick={() => onSave(values)}>
                    Đồng ý
                </Button>
            </Modal.Footer>
        </Modal>
        <Row>
            <Col span={24}>
                <form onSubmit={(e) => { e.preventDefault(); handleSubmit(); }}>
                    <Tabs
                        tabBarExtraContent={
                            <Button
                                htmlType="submit"
                                icon={<SaveOutlined rev="" />}
                                type="primary"
                            >
                                Lưu
                            </Button>
                        }
                        defaultActiveKey="1" items={[
                        {
                            key: '1',
                            label: 'Cấu hình hệ thống chung',
                            children:
                                <div className="card pt-3 pb-2">
                                    <div className="form-group row col-sm-12">
                                        <label className="col-sm-3 control-label">Host <span className="text-red">*</span>: </label>
                                        <div className="col-sm-3">
                                            <Form.Control
                                                id="hostMail"
                                                name="hostMail"
                                                type="text"
                                                placeholder="hostMail"
                                                onChange={handleChange}
                                                value={values.hostMail}
                                                isValid={touched.hostMail && !errors.hostMail}
                                                isInvalid={touched.hostMail && !!errors.hostMail}
                                            />
                                            {touched.hostMail && errors.hostMail ? (
                                                <Form.Control.Feedback type="invalid">
                                                    {errors.hostMail}
                                                </Form.Control.Feedback>
                                            ) : null}
                                        </div>
                                        <label className="col-sm-3 control-label">Port <span className="text-red">*</span>: </label>
                                        <div className="col-sm-3">
                                            <Form.Control
                                                id="portMail"
                                                name="portMail"
                                                type="text"
                                                placeholder="Port"
                                                onChange={handleChange}
                                                value={values.portMail}
                                                isValid={touched.portMail && !errors.portMail}
                                                isInvalid={touched.portMail && !!errors.portMail}
                                            />
                                            {touched.portMail && errors.portMail ? (
                                                <Form.Control.Feedback type="invalid">
                                                    {errors.portMail}
                                                </Form.Control.Feedback>
                                            ) : null}
                                        </div>
                                    </div>
                                    <div className="form-group row col-sm-12">
                                        <label className="col-sm-3 control-label">Username <span className="text-red">*</span>: </label>
                                        <div className="col-sm-3">
                                            <Form.Control
                                                id="userNameMail"
                                                name="userNameMail"
                                                type="text"
                                                placeholder="Username"
                                                onChange={handleChange}
                                                value={values.userNameMail}
                                                isValid={touched.userNameMail && !errors.userNameMail}
                                                isInvalid={touched.userNameMail && !!errors.userNameMail}
                                            />
                                            {touched.userNameMail && errors.userNameMail ? (
                                                <Form.Control.Feedback type="invalid">
                                                    {errors.userNameMail}
                                                </Form.Control.Feedback>
                                            ) : null}
                                        </div>
                                        <label className="col-sm-3 control-label">Password <span className="text-red">*</span>: </label>
                                        <div className="col-sm-3">
                                            <Form.Control
                                                id="passwordMail"
                                                name="passwordMail"
                                                type="password"
                                                placeholder="Password"
                                                onChange={handleChange}
                                                value={values.passwordMail}
                                                isValid={touched.passwordMail && !errors.passwordMail}
                                                isInvalid={touched.passwordMail && !!errors.passwordMail}
                                            />
                                            {touched.passwordMail && errors.passwordMail ? (
                                                <Form.Control.Feedback type="invalid">
                                                    {errors.passwordMail}
                                                </Form.Control.Feedback>
                                            ) : null}
                                        </div>
                                    </div>
                                    <div className="form-group row col-sm-12">
                                        <label className="col-sm-3 control-label">Cảnh báo hết hạn HĐ/QĐ bổ nhiệm/Nâng bậc (ngày) <span className="text-red">*</span>: </label>
                                        <div className="col-sm-3">
                                            <Form.Control
                                                id="thoiHan"
                                                name="thoiHan"
                                                type="number"
                                                placeholder="Thời hạn"
                                                onChange={handleChange}
                                                value={values.thoiHan}
                                                isValid={touched.thoiHan && !errors.thoiHan}
                                                isInvalid={touched.thoiHan && !!errors.thoiHan}
                                            />
                                            {touched.thoiHan && errors.thoiHan ? (
                                                <Form.Control.Feedback type="invalid">
                                                    {errors.thoiHan}
                                                </Form.Control.Feedback>
                                            ) : null}
                                        </div>
                                        <label className="col-sm-3 control-label">Hiển thị sinh nhật Quỹ <span className="text-red">*</span>: </label>
                                        <div className="col-sm-3">
                                            <Switch checked={stateSinhNhat}
                                                checkedChildren={<CheckOutlined rev="" />}
                                                unCheckedChildren={<CloseOutlined rev="" />}
                                                onChange={(e) => {
                                                    setStateSinhNhat(e);
                                                    setFieldValue("sinhNhatQuy", e === true ? 1 : 0);
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group row col-sm-12">
                                        <label className="col-sm-3 control-label">Duyệt nhu cầu tài sản - Phó CVP: </label>
                                        <div className="col-sm-3">
                                            <NhanVienSelectBox
                                                allowClear
                                                value={values.duyetNhuCauTaiSan_PhoCVP}
                                                onChange={(e: any) => setFieldValue("duyetNhuCauTaiSan_PhoCVP", e.target.value)}
                                            />
                                        </div>
                                        <label className="col-sm-3 control-label">Duyệt nhu cầu tài sản - CVP: </label>
                                        <div className="col-sm-3">
                                            <NhanVienSelectBox
                                                allowClear
                                                value={values.duyetNhuCauTaiSan_CVP}
                                                onChange={(e: any) => setFieldValue("duyetNhuCauTaiSan_CVP", e.target.value)}
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group row col-sm-12">
                                        <label className="col-sm-3 control-label">Duyệt nhu cầu tài sản - Phó GĐ: </label>
                                        <div className="col-sm-3">
                                            <NhanVienSelectBox
                                                allowClear
                                                value={values.duyetNhuCauTaiSan_PhoGD}
                                                onChange={(e: any) => setFieldValue("duyetNhuCauTaiSan_PhoGD", e.target.value)}
                                            />
                                        </div>
                                        <label className="col-sm-3 control-label">Duyệt nhu cầu tài sản - GĐ: </label>
                                        <div className="col-sm-3">
                                            <NhanVienSelectBox
                                                allowClear
                                                value={values.duyetNhuCauTaiSan_GD}
                                                onChange={(e: any) => setFieldValue("duyetNhuCauTaiSan_GD", e.target.value)}
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group row col-sm-12">
                                        <label className="col-sm-3 control-label">Duyệt nhu cầu tài sản - CV VP Tham mưu: </label>
                                        <div className="col-sm-3">
                                            <NhanVienSelectBox
                                                allowClear
                                                value={values.duyetNhuCauTaiSan_CVVP}
                                                onChange={(e: any) => setFieldValue("duyetNhuCauTaiSan_CVVP", e.target.value)}
                                            />
                                        </div>
                                    </div>
                                </div>
                        },
                    ]}>
                    </Tabs>
                </form>
                <CauHinhLuongTab />
                <CauHinhThueTab />
                <CauHinhHanChotKPITab />
                <SoHieuVanBanTab />
                <CauHinhKeHoachDaoTaoTab />
                <NgayLamViec />
            </Col>
        </Row>
    </section>
}

export default Setting